import linkedin from "../images/icon-linkedin.svg";
import github from "../images/icon-github.svg";
import email from "../images/email1.svg";

const contact = [
  {
    id: 1,
    name: "http://www.linkedin.com/in/anafruiz20",
    img: linkedin,
  },
  {
    id: 2,
    name: "https://github.com/anafruiz",
    img: github,
  },
  {
    id: 3,
    name: "mailto:anafruiz20@gmail.com",
    img: email,
  },
];
export default contact;
